export default __webpack_public_path__ + "static/sub-two-xl-ca209594c66c31ff0d37ce7ce97d5799.svg";